import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { PasswordInput } from "@components-shared/desktop/inputs";

export default observer(function DepositPasswordConfirmation() {
	const { t } = useTranslation("payment");

	return (
		<PasswordInput
			name="password"
			className="form__group"
			label={t<string>("DEPOSIT.PASSWORD_CONFIRM_MESSAGE")}
			placeholder={"payment:COMMON.PASSWORD_CONFIRMATION.PASSWORD_TITLE"}
			required
		/>
	);
});
